import { __require as n } from "./main37.js";
import { __require as s } from "./main38.js";
var e, t;
function f() {
  if (t) return e;
  t = 1;
  var a = n(), i = s();
  function u(v, _) {
    var r = i(v, _);
    return a(r) ? r : void 0;
  }
  return e = u, e;
}
export {
  f as __require
};
